var exports = {
  "q": "fadeIn__1-XvZh",
  "C": "animated___n3Rbz",
};

module.exports = exports;
